import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
export default function fixInlineImageSrc(viewState) {
    return function (cidOrName) {
        if (viewState.attachmentWell && viewState.attachmentWell.inlineAttachments) {
            for (var _i = 0, _a = viewState.attachmentWell.inlineAttachments; _i < _a.length; _i++) {
                var attachmentData = _a[_i];
                var attachment = getAttachment(attachmentData.attachmentId);
                if (attachment &&
                    attachment.model &&
                    (attachment.model.ContentId == cidOrName || attachment.model.Name == cidOrName)) {
                    return {
                        url: attachment.model.AttachmentOriginalUrl,
                        contentId: attachment.model.ContentId,
                    };
                }
            }
        }
        return null;
    };
}
//# sourceMappingURL=fixInlineImageSrc.js.map